export default __webpack_public_path__ + "static/media/SASERP_LOGO.6dea8da7.png";